'use strict'

const list = require('../../data/portal2/templates/_index')
const _ = require('lodash')

let config = {}
list.forEach(t => {
	config[t.name] = {}
	let template = t.name

	if (t.template) {
		template = t.template
	}

	try {
		config[t.name] = require('../../data/portal2/templates/' + t.name + '/' + t.name + '.json')
	} catch(err) { err }
	try {
		config[t.name] = _.defaultsDeep(config[t.name], require('../../src/templates/' + t.name + '/' + t.name + '.json'))
	} catch(err) { err }

	try {
		config[t.name].preview = require('../../data/portal2/templates/' + t.name + '/' + t.name + '.preview.html')
	} catch(err) { err
		try {
			config[t.name].preview = require('../../src/templates/' + t.name + '/' + t.name + '.preview.html')
		} catch(err) { err
			try {
				config[t.name].preview = require('../../data/portal2/templates/' + template + '/' + template + '.preview.html')
			} catch(err) { err
				config[t.name].preview = require('../../src/templates/' + template + '/' + template + '.preview.html')
			}
		}
	}

	config[t.name]._page = t.name
	if (config[t.name].ignore) {
		delete config[t.name]
	}
})

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./src/templates/_index.js
// module id = 414
// module chunks = 0